/* eslint-disable prettier/prettier */
import React, { Fragment } from 'react';
import Banner from '../../components/Banner';
import Section from '../../components/Section';

/**
 * Teens component
 *
 * @param {object} props
 */
const Teens = () => {
  return (
    <Fragment>
      <Banner
        title="Teenagers at The Gym at Moffat"
        subtitle="12 to 15 years"
        imageUrl="/assets/img/vault.jpeg"
      />
      <Section
        title="Benefits"
        imageUrl="/assets/img/weights.jpeg"
        text={
          <Fragment>
            <p className="gel-pica gs-u-mb+">
              The Gym at Moffat is committed to providing a safe, welcoming
              environment where teens can stay active, build confidence, and
              connect with others in their community.
            </p>
            <p className="gel-pica gs-u-mb++">
              Regular physical activity offers important benefits like improved
              mental well-being, increased energy, and enhanced self-esteem,
              while also helping to manage stress.
            </p>
            <p className="gel-pica">
              Many teens already enjoy the facilities, and the gym’s friendly
              staff are always available to offer guidance and support, helping
              new members feel comfortable and confident.
            </p>
          </Fragment>
        }
      />
      <Section
        title="Activities, Classes & Facilities"
        isReversed
        imageUrl="/assets/img/background.jpeg"
        text={
          <Fragment>
            <p className="gel-pica gs-u-mb+">
              Teens at The Gym at Moffat have access to a variety of activities,
              including memberships, fitness classes, personal training,
              gymnastics, and sports like badminton, pickleball, indoor
              football, and indoor tennis.
            </p>
            <p className="gel-pica gs-u-mb++">
              All classes are open to teens, including sessions in a darkened,
              interactive spin room designed to create a more immersive and
              comfortable workout environment.
            </p>
            <p className="gel-pica">
              Teen members can also enjoy free court access for various sports,
              although adult supervision is required.
            </p>
          </Fragment>
        }
      />
      <Section
        title="Membership, Rules & Hours"
        imageUrl="/assets/img/weights.jpeg"
        text={
          <Fragment>
            <p className="gel-pica gs-u-mb+">
              Teen memberships are available for ages 12 to 15, starting at £15
              per month, with an option to include unlimited class access for
              £20 per month, along with discounts for annual plans and
              pay-as-you-go options.
            </p>
            <p className="gel-pica gs-u-mb++">
              A complimentary gym induction is required for all new members to
              ensure they are familiar with the facilities and equipment.
              Members under 16 must be accompanied by an adult and need
              permission and training from the manager to use free weights.
            </p>
            <p className="gel-pica">
              Staff supervision is offered Monday to Thursday from 4:00 PM to
              7:00 PM, and a dedicated “Teen Hour” with a personal trainer takes
              place every Wednesday from 4:00 PM to 5:00 PM.
            </p>
          </Fragment>
        }
      />
    </Fragment>
  );
};

export default Teens;
